<template>
  <sidebar-wrapper
    small @show-search="onShowSearch" @search="onSearch"
    class="sidebar-border-r-0"
    :class="{'hide-left-sidebar hide-sidebar-operator': currentChatUser}"
  >
    <template v-slot:title>
      Users
    </template>

    <p v-if="!users.length" class="text-center py-2 text-gray">No users</p>

    <ul class="user-list">
      <li class="user-list-item" v-for="user in filtered" :key="user.id">
        <a
          :class="{
            'bg-chat-selected': currentChatUser && currentChatUser.id === user.id,
            'bg-unseen': newMessagesCountForUser(user.id),
          }"
          @click.prevent="selectOperatorUser(user)"
        >
          <UserAvatar :user="user"/>

          <div class="users-list-body d-flex align-items-center">
            <div class="text-truncate">
              <h5>
                {{ user.profile.display_name }}
              </h5>
            </div>

            <div class="last-chat-time">
              <div class="chat-pin">
                <div v-if="unseenMessagesForOperatorUser(user.id)" class="new-message-count me-2">
                  {{ unseenMessagesForOperatorUser(user.id) }}
                </div>
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </sidebar-wrapper>
</template>

<script>
import {mapGetters} from "vuex";
import {conversationTimeFormat} from '@/util';
import UserAvatar from "@/components/frontend/UserAvatar";

export default {
  components: {UserAvatar},
  watch: {
    //
  },

  data() {
    return {
      showSearch: false,
      searchInput: '',
    };
  },

  computed: {
    ...mapGetters({
      conversations: 'chat/conversations',
      unseenMessagesForOperatorUser: 'chat/unseenMessagesForOperatorUser',
      activeUsers: 'chat/activeUsers',
      conversationTyping: 'chat/conversationTyping',
      newMessagesCount: 'chat/newMessagesCount',
      users: 'chat/internalUsers',
      unseenMessages: 'chat/unseenMessages',
      currentChatUser: 'chat/currentChatUser',
      newMessagesCountForUser: 'chat/newMessagesCountForUser',
    }),

    filtered() {
      if (this.searchInput) {
        return this.users.filter(e => {
          return e.profile.display_name.toLowerCase().trim().includes(
            this.searchInput.toLowerCase().trim()
          );
        });
      }

      return this.users;
    },
  },

  methods: {
    conversationTimeFormat,

    onShowSearch(value) {
      this.showSearch = value;
    },

    onSearch(value) {
      this.searchInput = value;
    },

    selectOperatorUser(user) {
      this.$store.commit('chat/setCurrentChatUser', user);
    },
  },
};
</script>
